<template>
  <div>
    <!-- <div class="prop-title">
      <i v-if="showUi" @click="clickBackBtn" class="material-icons" style="font-size:28px; padding-top:2px; cursor:pointer;">keyboard_arrow_left</i>
      <slot name="title"></slot>
      <span style="margin-left: 4px;"> 설정</span>
    </div> -->
    <div v-if="hideTab!==undefined" style="padding: 20px 16px;">
      <div><slot name="styles"></slot></div>
    </div>
    <div v-else>
      <div class="flex">
        <div class="tab" :class="{'selected':tab===1}" @click="tab=1">디자인</div>
        <div class="tab" :class="{'selected':tab===2}" @click="tab=2">컨텐츠</div>
        <div class="tab" :class="{'selected':tab===3}" @click="tab=3">링크</div>
      </div>
      <div v-if="tab===1" style="height: calc(100vh - 134px); overflow-y: auto;"><slot name="styles"></slot></div>
      <div class="cont" v-if="tab===2" style="height: calc(100vh - 134px); overflow-y: auto;"><slot name="datas"></slot></div>
      <div class="cont" v-if="tab===3" style="height: calc(100vh - 134px); overflow-y: auto;"><slot name="actions"></slot></div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['showUi', 'hideTab'],
  data() {
    return {
      tab: 1
    }
  },
  created() {
    this.routes
  },
  methods: {
    clickBackBtn() {
      this.$emit('clickBack');
    }
  }
}
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_variable'
  .flex
    display flex
    width 100%

  .prop-title
    padding 10px 12px
    font-size 1rem
    color $primary
    border-bottom 1px solid $primary
    background-color white
    display: flex
    align-items center

  .tab
    width 33.333%
    padding 8px
    text-align center
    font-size 0.9rem
    color #888
    background-color transparent
    border-bottom 1px solid #ddd
    cursor pointer

  .selected
    border-bottom 3px solid $primary

  .cont
    padding 12px
</style>
